"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "User___StyledSvg",
  componentId: "zoiz4c-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function User(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18H2c0-.36-.001-.722.001-1.083a5.413 5.413 0 01.234-1.49 5.107 5.107 0 01.904-1.697c.952-1.193 2.355-1.944 3.808-2.342a11.099 11.099 0 011.46-.29 12.868 12.868 0 012.879-.034 11.425 11.425 0 011.582.275c1.52.386 3.001 1.147 3.993 2.39.178.223.338.46.478.708.19.336.34.694.45 1.065.143.487.207.99.211 1.498v1zm-8.097-5.4c-.373.005-.745.024-1.116.065a9.595 9.595 0 00-.858.134 8.542 8.542 0 00-1.225.347c-1.03.385-2.016 1.025-2.594 1.983a3.534 3.534 0 00-.459 1.245l-.004.026h12.707a3.605 3.605 0 00-.52-1.361c-.572-.888-1.496-1.492-2.467-1.866a8.353 8.353 0 00-1.212-.357 9.502 9.502 0 00-.853-.14 11.31 11.31 0 00-1.399-.076zM10.052 2a4.035 4.035 0 011.681.395 4.033 4.033 0 011.913 1.96c.353.778.444 1.664.262 2.499a3.983 3.983 0 01-1.15 2.04 3.993 3.993 0 01-5.375.13 3.985 3.985 0 01-1.106-4.489 4.037 4.037 0 011.817-2.051A4.03 4.03 0 0110.053 2zm-.083 1.6a2.41 2.41 0 00-.953.211 2.424 2.424 0 00-1.154 1.1 2.398 2.398 0 004.22 2.28 2.4 2.4 0 00-2.113-3.59z",
    fill: "currentColor"
  }));
}

var _default = User;
exports["default"] = _default;